<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
export default {
	name: 'App',
	components: {},
}
</script>

<style>
/* 在线链接服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
@font-face {
	font-family: 'Alimama DongFangDaKai';
	font-weight: 400;
	src: url('//at.alicdn.com/wf/webfont/AnuWpCYqilwD/E0DQ3BjLH7oD.woff2') format('woff2'), url('//at.alicdn.com/wf/webfont/AnuWpCYqilwD/UFM8tuaOrK8v.woff') format('woff');
	font-display: swap;
}
#app {
	min-width: 1200px;
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	/* text-align: center; */
	color: #2c3e50;
	/* margin-top: 60px; */
	margin: 0;
	padding: 0;
	height: 100vh;
	background: #f9f9f9;
	/* min-width: 1920px; */
}
body {
  
	margin: 0;
	padding: 0;
}
</style>
